<template>
    <tab-frame>
        <div class="u-head">
            <div class="icon icon-user11"></div>
            {{ user.name }}
            <small><small>（{{ user.role }}）</small></small>
        </div>
        <mt-cell title="姓名">{{ user.name }}</mt-cell>
        <mt-cell title="角色">{{ user.role }}</mt-cell>
        <mt-cell title="手机号码">{{ user.phone }}</mt-cell>
        <mt-cell title="注册日期">{{ user.registerTime }}</mt-cell>
        <mt-cell title="批量计费" is-link :to="`/mine/applypay`" v-if="user.role && user.role.includes('公证员')">点击进入</mt-cell>
        <mt-cell title="公证书操作" is-link :to="`/mine/notarizationnumber`">点击进入</mt-cell>
    </tab-frame>
</template>

<script>
    export default {
        name: "Mine",
        data() {
            return {
                user: this.$store.state.notaryInfo || {},
            }
        },
    }
</script>

<style scoped lang="scss">
    .u-head {
        display: flex;
        align-items: center;
        font-size: 24px;
        font-weight: bold;
        padding: 10px;
        background: #26A2FF;
        color: #fff;
        .icon {
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 15px 0 0;
            height: 60px;
            width: 60px;
            border-radius: 50%;
            font-size: 35px;
            color: #fff;
            border: 1px solid #fff;
        }
    }
</style>
